const locale: Locale = {
  ko: {
    previous: '이전',
    next: '다음',
  },
  en: {
    previous: 'prev',
    next: 'next',
  },
}

export default locale
